import {
  GetInspectionType,
  PutInspectionType,
  GetQcType,
  GetQcTypeList,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface GetInspectionTypeParam {
  rmaNo: string;
  categoryId: string;
  typeId: string;
}

export interface GetQcTypeParam {
  rmaNo: string;
  categoryId: string;
  typeId: string;
}

export interface GetQcTypeAllParam {
  rmaNo: string;
}

const endPoint = 'inspection/type';
const endPointQc = 'qc/type';
const endPointQcAll = 'qc/all';

export const fetchInspectionTypeData = async (
  params: GetInspectionTypeParam,
): Promise<GetInspectionType> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  queryParams.append('categoryId', params.categoryId);
  queryParams.append('typeId', params.typeId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateInspectionTypeData = async (
  newInspectionType: PutInspectionType,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newInspectionType),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const fetchQcType = async (
  params: GetQcTypeParam,
): Promise<GetQcType> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  queryParams.append('categoryId', params.categoryId);
  queryParams.append('typeId', params.typeId);
  const apiUrl = getApiUrl(endPointQc);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const fetchQcTypeAll = async (
  params: GetQcTypeAllParam,
): Promise<GetQcTypeList> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPointQcAll);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateQcType = async (
  newQcType: PutInspectionType,
): Promise<void> => {
  const url = getApiUrl(endPointQc);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newQcType),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
